import { useState, ChangeEvent } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Col } from "reactstrap";
import { Back, NumberingWizardTitle } from "../../../../../../constants";
import BasicInfoForm from "./BasicInfoForm";
import CartInfoForm from "./CartInfoForm";
import FeedbackForm from "./FeedbackForm";
import FinishForm from "../../common/FinishForm";
import StepperHorizontal from "./StepperHorizontal";
import { NumberingWizardSubTitle } from "../../../../../../data/formsAndTable/forms/FormLayout";
import { BasicFormItems } from "../../../../../../types/Forms";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";

const NumberingWizard = () => {
  const [step, setStep] = useState(1);
  const [showFinish, setShowFinish] = useState(false);
  const [finishClicked, setFinishClicked] = useState(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
  } = useForm<BasicFormItems>({});

  const formData = watch(); // Store watched values so that they persist between steps

  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    let value: string | boolean = "";
    if (name === "agreeTerms" || name === "informationCheckBox" || name === "agreeConditions") {
      value = event.target.checked;
    } else if (name === "uploadDocumentation") {
      value = event.target.files && event.target.files[0] ? event.target.files[0].name : "";
    } else {
      value = event.target.value ?? "";
    }
    setValue(name as keyof BasicFormItems, value, { shouldValidate: true, shouldDirty: true });
  };

  const handleBackButton = () => {
    setShowFinish(false);
    setStep((prev) => prev - 1);
    setFinishClicked(false);
  };

  const handleNextButton = handleSubmit(
    () => {
      if (step === 1 && formData.email && formData.firstName && formData.password && formData.confirmPassword && formData.agreeTerms) {
        setStep(2);
      } else if (step === 2 && formData.placeHolderName && formData.cardNumber && formData.expiration && formData.cvvNumber && formData.uploadDocumentation && formData.informationCheckBox) {
        setStep(3);
      } else if (step === 3 && formData.linkedInLink && formData.gitHubLink && formData.giveFeedBack && formData.state && formData.agreeConditions) {
        setStep(4);
        setShowFinish(true);
      }
    },
    () => {
      toast.error("Please fill out all the fields before moving on to the next step");
    }
  );

  const handleFinishButton = () => {
    setFinishClicked(true);
    return toast.success("Successfully Completed");
  };
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={NumberingWizardTitle} span={NumberingWizardSubTitle} />
        <CardBody className="basic-wizard important-validation">
          <div className="stepper-horizontal custom-scrollbar" id="stepper1">
            <StepperHorizontal step={step} finishClicked={finishClicked} />
          </div>
          <div id="msform">
            {step === 1 && <BasicInfoForm register={register} errors={errors} updateFormData={updateFormData} formData={formData} />}
            {step === 2 && <CartInfoForm register={register} errors={errors} updateFormData={updateFormData} formData={formData} />}
            {step === 3 && <FeedbackForm register={register} errors={errors} updateFormData={updateFormData} formData={formData} />}
            {step === 4 && <FinishForm />}
          </div>
          <div className="wizard-footer d-flex gap-2 justify-content-end">
            {step > 1 && (
              <Button color="" className="alert-light-primary" onClick={handleBackButton}>
                {Back}
              </Button>
            )}
            <Button disabled={finishClicked} color="primary" onClick={showFinish ? handleFinishButton : handleNextButton}>
              {showFinish ? "Finish" : "Next"}
            </Button>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default NumberingWizard;
